import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./HomePage";
import ContactPage from "./components/ContactPage";
import AboutPage from "./components/AboutPage";
import MyAccountPage from "./components/MyAccountPage";
import CreateExam from "./components/exam/CreateExam"
import ExamQuestionPage from "./components/exam/ExamQuestionPage";
import IAATExamples from "./components/iaat/IAATExamples";
import IAAT from "./components/iaat/IAAT";
import Cogat from "./components/cogat/Cogat";
import Nnat from "./components/nnat/Nnat";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/account" element={<MyAccountPage />} />
        <Route path="/contact" element={<ContactPage />} /> 
        <Route path="/about" element={<AboutPage />} /> 
        <Route path="/createexam" element={<CreateExam />} /> 
        <Route path="/exam/:exam_id" element={<ExamQuestionPage />} />
        <Route path="IAATExample" element={<IAATExamples />}/>
        <Route path="iaat" element={<IAAT />}/>
        <Route path="cogat" element={<Cogat />}/>
        <Route path="nnat" element={<Nnat />}/>
      </Routes>
    </Router> 
  );
}

export default App;
